import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { FormCard } from "../../../components/FormControls/FormCard";
import { TextAreaWithCount } from "../../../components/Inputs";

interface ParentNoteFormCardProps {
  value?: string;
  readonly?: boolean;
  disabled?: boolean;
  onChange?: (value: string) => void;
}

const MAX_LENGTH = 1000;

export function ParentNoteFormCard({
  value = "",
  readonly,
  disabled,
  onChange,
}: ParentNoteFormCardProps) {
  const { t } = useTranslation();

  const handleChange = (value: string) => {
    onChange?.(value);
  };

  return (
    <FormCard cardTitle={t("common.institutionDetails.parentNoteTitle")}>
      <Row>
        <Col md={12}>
          <TextAreaWithCount
            ariaLabel={t("common.institutionDetails.parentNoteLabel")}
            label={t("common.institutionDetails.parentNoteLabel")}
            disabled={disabled}
            value={value}
            readonly={readonly}
            onChange={handleChange}
            maxLength={MAX_LENGTH}
          />
        </Col>
      </Row>
    </FormCard>
  );
}
